import React, { useState } from "react";
import "./COC.css";
import moment from "moment";
import { apiCall } from "../api/apiUtil";
import { useNavigate } from "react-router-dom";
import {
	Row,
	Col,
	Button,
	Card,
	Table,
	Form,
	Container,
	Modal,
	Tabs,
	Tab,
} from "react-bootstrap";
import {
	FaTachometerAlt,
	FaCalendarAlt,
	FaUsers,
	FaUser,
	FaArrowRight,
	FaSpinner,
} from "react-icons/fa"; // Import Calendar Icon
import { FaCircleStop, FaCloudArrowDown, FaHand, FaBan } from "react-icons/fa6";

const Codeofconduct3 = () => {
	// alert(sessionStorage.getItem("Id"));
	// console.log("Id-", sessionStorage.getItem("Id"));
	const [complianceId, setComplianceId] = useState(
		sessionStorage.getItem("Id")
	);
	const [isChecked, setIsChecked] = useState(false);

	const [businessList, setBusinessList] = useState([
		{ name: "", ownership: "", owner: "", relationship: "" },
	]);
	const [globalId, setGlobalId] = useState(
		sessionStorage.getItem("globalCode")
	);
	const [year, setYear] = useState(sessionStorage.getItem("year"));
	const [month, setMonth] = useState(sessionStorage.getItem("month"));
	const [signature, setSignature] = useState("");
	const [disableSubmitButton, setDisableSubmitButton] = useState(true);
	const [formData, setFormData] = useState({
		GlobalCode: sessionStorage.getItem("globalCode"),
		EmpCode: sessionStorage.getItem("globalCode"),
		Name: sessionStorage.getItem("userName"),
		Email: sessionStorage.getItem("userEmail"),
		Department: sessionStorage.getItem("departmentName"),
		Designation: sessionStorage.getItem("designationName"),
		StartDate: moment(sessionStorage.getItem("startDate")).format("YYYY-MM-DD"),
		EndDate: moment(sessionStorage.getItem("endDate")).format("YYYY-MM-DD"),
		Year: sessionStorage.getItem("year"),
		Month: sessionStorage.getItem("month"),
		Period: sessionStorage.getItem("period"),
		ConflictStatus: 0,
		ActualConflict: 0,
		ActualDescription: "",
		PotentialConflict: 0,
		PotentialDescription: "",
		PerceivedConflict: 0,
		PerceivedDescription: "",
		BusinessinterestStatus: 0,
		BusinessinterestList: JSON.stringify(businessList),
		// Signature: "",
		Date: moment().format("YYYY-MM-DD"),
		Place: sessionStorage.getItem("place"),
		CreatedOn: moment().format("YYYY-MM-DD HH:mm:ss"),
		Published: 0,
	});

	const [showModal, setShowModal] = useState(false);
	const [fileUploadingFlag, setFileUploadingFlag] = useState(false);

	const navigate = useNavigate();

	const handleChange = (e) => {
		const { name, value } = e.target;
		// Handle conflictStatus updates differently
		if (name === "ConflictStatus") {
			setFormData((prev) => ({
				...prev,
				ConflictStatus: value === "1" ? 1 : 0,
			}));
		} else if (name === "BusinessinterestStatus") {
			setFormData((prev) => ({
				...prev,
				BusinessinterestStatus: value === "1" ? 1 : 0,
			}));
		} else {
			setFormData((prev) => ({ ...prev, [name]: value }));
		}
	};

	const handleCheckboxChange = (section, value) => {
		setFormData((prev) => {
			const updated = prev[section].includes(value)
				? prev[section].filter((item) => item !== value)
				: [...prev[section], value];
			return { ...prev, [section]: updated };
		});
	};

	const removeBusinessInterestRow = (indexToRemove) => {
		setBusinessList(businessList.filter((_, i) => i !== indexToRemove));
	};

	const handleConflictTypeChange = (type) => {
		setFormData((prev) => ({
			...prev,
			[type]: prev[type] === 1 ? 0 : 1, // Toggle between 0 and 1
		}));
	};

	const handleConflictDescriptionChange = (type, value) => {
		setFormData((prev) => ({
			...prev,
			[`${type}Description`]: value,
		}));
	};

	const handleBusinessInterestChange = (index, field, value) => {
		const updated = [...businessList];
		updated[index][field] = value;
		setBusinessList(updated);
	};

	const addBusinessInterestRow = () => {
		setBusinessList([
			...businessList,
			{ name: "", ownership: "", owner: "", relationship: "" },
		]);
	};

	// Handle File Upload
	//   const handleFileUpload = (event) => {
	//     const file = event.target.files[0];
	//     if (file != null) {
	//       UploadSignature(globalId, year, month, file);
	//     }
	//   };
	//   const UploadSignature = async (globalId, year, month, file) => {
	//     setFileUploadingFlag(true);
	//     const formData = new FormData();
	//     formData.append("file", file);
	//     console.log("FILE Data:", JSON.stringify(formData));
	//     const response = await apiCall(
	//       `/CodeofconductForm/UploadSignature/${globalId}/${year}/${month}`,
	//       {
	//         method: "POST",
	//         body: formData,
	//       }
	//     );
	//     setFileUploadingFlag(false);
	//     if (response?.success) {
	//       setSignature(response?.fileDetail);
	//       //   setDisableSubmitButton(false);

	//       alert("Signature Uploaded.");
	//     } else {
	//       alert("Some issue occur. Please try uploading again.");
	//     }
	//   };
	const handleSubmit = async (e) => {
		e.preventDefault();
		if (isChecked === false) {
			alert("Acceptance of Code of Conduct compliance is required.");
			return;
		}
		if (
			formData.ConflictStatus === 1 &&
			formData.ActualConflict === 0 &&
			formData.PotentialConflict === 0 &&
			formData.PerceivedConflict === 0
		) {
			alert("Please select at least one type of Conflict of Interest.");
			return;
		}
		if (
			formData.ConflictStatus === 1 &&
			formData.ActualConflict === 1 &&
			formData.ActualDescription === ""
		) {
			alert("Avail the details against the Actual Conflict of Interest.");
			return;
		}
		if (
			formData.ConflictStatus === 1 &&
			formData.PotentialConflict === 1 &&
			formData.PotentialDescription === ""
		) {
			alert("Avail the details against the Potential Conflict of Interest.");
			return;
		}
		if (
			formData.ConflictStatus === 1 &&
			formData.PerceivedConflict === 1 &&
			formData.PerceivedDescription === ""
		) {
			alert("Avail the details against the Perceived Conflict of Interest.");
			return;
		}
		// if (formData.BusinessinterestStatus === 1) {
		// 	alert("Please provide at least one business interest.");
		// 	return;
		// }

		//e.preventDefault();

		let codeOfConductForm = formData;
		if (
			businessList[0]?.name != "" &&
			businessList[0]?.ownership != "" &&
			businessList[0]?.owner != "" &&
			businessList[0]?.relationship != ""
		) {
			codeOfConductForm.BusinessinterestList = JSON.stringify(businessList);
		} else {
			codeOfConductForm.BusinessinterestList = "[]";
		}

		// codeOfConductForm.Signature = JSON.stringify(signature);
		setFormData(codeOfConductForm);
		//console.log("Form Data:", JSON.stringify(formData));
		try {
			const response = await apiCall("/CodeOfConductForm/SaveCodeofconduct", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(formData),
			});

			if (response?.success) {
				alert(response?.message);
				navigate("/user-dashboard");
			} else {
				console.error("Failed to submit data");
			}
		} catch (error) {
			console.error("Error during form submission:", error);
		}
	};

	return (
		<div id="coc-form" className="d-flex flex-column min-vh-100">
			<form onSubmit={handleSubmit}>
				{/* className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-xl space-y-6"
        			className="w-full px-4 sm:px-6 lg:px-8 bg-white shadow-lg rounded-xl space-y-6" */}

				<h2 className="text-2xl font-bold text-center">
					Employee Self-Declaration Form
				</h2>
				<p className="text-center font-medium">
					Code of Conduct, Ethical Business Practices Compliance, and Disclosure
					of Conflict of Interest & Business Interests
				</p>

				{/* Employee Info */}
				<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
					<div>
						<label className="font-semibold">
							<span style={{ color: "red" }}>*</span>Full Name:
						</label>
						<input
							type="text"
							name="Name"
							value={formData.Name}
							onChange={handleChange}
							className="w-full border p-2 rounded mb-4"
							required
							readOnly
						/>
					</div>
					<div>
						<label className="font-semibold">
							<span style={{ color: "red" }}>*</span>Employee ID:
						</label>
						<input
							type="text"
							name="GlobalCode"
							value={formData.GlobalCode}
							onChange={handleChange}
							className="w-full border p-2 rounded mb-4"
							required
							readOnly
						/>
					</div>
					<div>
						<label className="font-semibold">
							<span style={{ color: "red" }}>*</span>Designation:
						</label>
						<input
							type="text"
							name="Designation"
							value={formData.Designation}
							onChange={handleChange}
							className="w-full border p-2 rounded mb-4"
							required
							readOnly
						/>
					</div>
					<div>
						<label className="font-semibold">
							<span style={{ color: "red" }}>*</span>Department:
						</label>
						<input
							type="text"
							name="Department"
							value={formData.Department}
							onChange={handleChange}
							className="w-full border p-2 rounded mb-4"
							required
							readOnly
						/>
					</div>
				</div>

				{/* Sections with bullet points */}
				<div>
					<h3 className="text-xl font-semibold mt-6">
						1. Code of Conduct Compliance
					</h3>
					<input
						type="checkbox"
						id="myCheckbox"
						checked={isChecked}
						onChange={() => setIsChecked(!isChecked)} style={{ marginTop: "15px" }}
					/>
						I acknowledge that I have received, read and fully understood the Jindal Group Code of Conduct (Version 3.0). I pledge to comply with the Code in its true letter and spirit.
					{" "}
					<>
						(Visit <a href="https://jsplconnect.jindalsteel.com" target="_blank">https://jsplconnect.jindalsteel.com <span>&raquo;</span> Policies <span>&raquo;</span> General Policies <span>&raquo;</span> Code of Conduct</a>)
					</>
					<ul className="list-disc list-inside space-y-1">
						<li>
							I confirm that I have disclosed all actual and potential conflicts of interest known to me as at the date of this pledge. I understand that failure to make required disclosures is itself a violation of the Code.
						</li>
						<li>
							If I learn of a violation of the Code, I will report it to my Superior, the Business Head, or the Vigilance Cell without delay. If I fail to receive an adequate response, I will escalate to the Audit Committee of the Board.
						</li>
						<li>
							I acknowledge that the Code is not a contract and does not alter the Terms and Conditions of my employment. I understand that violations of the Code may result in disciplinary action up to and including termination and referral for criminal prosecution.
						</li>
					</ul>
				</div>

				{/* Conflict of Interest */}
				<div>
					<h3 className="text-xl font-semibold mt-6">
						2. Declaration of Conflict of Interest
					</h3>
					<p className="mb-4">
						I understand my responsibility to disclose any actual, potential, or
						perceived conflict of interest in relation to my role or
						responsibilities within the Company.
					</p>
					<label className="block mb-2">
						<input
							type="radio"
							name="ConflictStatus"
							value="0"
							checked={formData.ConflictStatus === 0}
							onChange={handleChange}
							className="mr-2"
						/>
						No Conflict of Interest
					</label>
					<p className="ml-6 text-sm italic mb-2">
						I hereby declare that I have no actual, potential, or perceived
						conflict of interest, and I commit to performing my duties with
						impartiality and integrity.
					</p>
					<label className="block mb-2">
						<input
							type="radio"
							name="ConflictStatus"
							value="1"
							checked={formData.ConflictStatus === 1}
							onChange={handleChange}
							className="mr-2"
						/>
						Conflict of Interest Exists
					</label>
					{formData.ConflictStatus === 1 && (
						<div className="ml-4 mt-4 space-y-4">
							{["Actual", "Potential", "Perceived"].map((type) => (
								<div key={type}>
									<label className="block font-medium">
										<input
											type="checkbox"
											checked={formData[`${type}Conflict`] === 1} // Check if 1 (true) or 0 (false)
											onChange={() =>
												handleConflictTypeChange(`${type}Conflict`)
											}
											className="mr-2"
										/>
										{type.charAt(0).toUpperCase() + type.slice(1)}:{" "}
										{type === "Actual"
											? "A present conflict, e.g., a close relative is a director or stakeholder in a company dealing with Jindal."
											: type === "Potential"
												? "A foreseeable conflict, e.g., a relative is being considered for employment at Jindal or a relative is being considered for appointment as Key Managerial Person (KMP) of an entity having business partnership with Jindal."
												: "A relationship or situation that may reasonably appear to affect impartiality, e.g., close friendship with a vendor executive."}
									</label>
									{formData[`${type}Conflict`] === 1 && (
										<textarea
											placeholder={`Describe the ${type} Conflict...`}
											value={formData[`${type}Description`]}
											onChange={(e) =>
												handleConflictDescriptionChange(
													`${type}`,
													e.target.value
												)
											}
											className="w-full border p-2 rounded mt-2"
											rows={3} maxLength={1000}
										/>
									)}
								</div>
							))}
						</div>
					)}
				</div>

				{/* Business Interests */}
				<div>
					<h3 className="text-xl font-semibold mt-6">
						3. Declaration of Business Interests
					</h3>
					<p className="mb-2">
						In accordance with the principles of transparency and integrity, I
						hereby declare any business interest or significant ownership
						(&gt;5%) held by myself or my close relatives in any company that
						engages in business with Jindal or its affiliates.
					</p>
					<label className="block mb-2">
						<input
							type="radio"
							name="BusinessinterestStatus"
							value="0"
							checked={formData.BusinessinterestStatus === 0}
							onChange={handleChange}
						/>{" "}
						I have no such business interests to declare.
					</label>
					<label className="block mb-4">
						<input
							type="radio"
							name="BusinessinterestStatus"
							value="1"
							checked={formData.BusinessinterestStatus === 1}
							onChange={handleChange}
						/>{" "}
						I declare the following interests:
					</label>
					{formData.BusinessinterestStatus === 1 && (
						<div className="w-full overflow-auto">
							<table className="w-full border-collapse">
								<thead>
									<tr>
										<th className="border px-4 py-2">Business/Company Name</th>
										<th className="border px-4 py-2">% Ownership</th>
										<th className="border px-4 py-2">Owner Name</th>
										<th className="border px-4 py-2">
											Relationship (Self/Relative)
										</th>
										<th className="border px-4 py-2">Actions</th>
									</tr>
								</thead>
								<tbody>
									{businessList?.map((interest, index) => (
										<tr key={index}>
											<td className="border px-4 py-2">
												<input
													type="text"
													placeholder="Company Name"
													value={interest.name}
													onChange={(e) =>
														handleBusinessInterestChange(
															index,
															"name",
															e.target.value
														)
													}
													className="w-full border p-2 rounded" required
												/>
											</td>
											<td className="border px-4 py-2">
												<input
													type="number"
													placeholder="% Ownership"
													value={interest.ownership}
													min={1} max={100}
													onChange={(e) =>
														handleBusinessInterestChange(
															index,
															"ownership",
															e.target.value
														)
													}
													className="w-full border p-2 rounded" required
												/>
											</td>
											<td className="border px-4 py-2">
												<input
													type="text"
													placeholder="Owner Name"
													value={interest.owner}
													onChange={(e) =>
														handleBusinessInterestChange(
															index,
															"owner",
															e.target.value
														)
													}
													className="w-full border p-2 rounded" required
												/>
											</td>
											<td className="border px-4 py-2">
												<input
													type="text"
													placeholder="Relationship"
													value={interest.relationship}
													onChange={(e) =>
														handleBusinessInterestChange(
															index,
															"relationship",
															e.target.value
														)
													}
													className="w-full border p-2 rounded" required
												/>
											</td>
											<td className="border px-4 py-2 text-left space-x-2">
												{businessList?.length > 1 && (
													<button
														type="button"
														onClick={() => removeBusinessInterestRow(index)}
														className="text-red-600 font-semibold"
													>
														- Remove
													</button>
												)}
												{index === businessList?.length - 1 && (
													<>{businessList?.length > 1 && (<br />)}
													<button
														type="button"
														onClick={addBusinessInterestRow}
														className="text-blue-600 font-semibold"
													>
														+ Add
													</button>
													</>
												)}
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					)}
				</div>

				<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
					{/*<div>
            <label className="font-semibold">
              <span style={{ color: "red" }}>*</span>Upload Your Signature:
            </label>
            <input
              type="file"
              onChange={(event) => handleFileUpload(event)}
              className="w-full border p-2 rounded"
              required
            />
          </div> */}
					<div>
						<label className="font-semibold">
							<span style={{ color: "red" }}>*</span>Date:
						</label>
						<input
							type="date"
							name="Date"
							value={formData.Date}
							onChange={handleChange}
							className="w-full border p-2 rounded"
							required
							readOnly
						/>
					</div>
					<div>
						<label className="font-semibold">
							<span style={{ color: "red" }}>*</span>Place:
						</label>
						<input
							type="text"
							name="Place"
							value={formData.Place}
							onChange={handleChange}
							className="w-full border p-2 rounded"
							required
							readOnly
						/>
					</div>
					<div>
						<button
							type="submit"
							//   disabled={disableSubmitButton}
							className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700"
							style={{marginTop: "33px"}}
						>
							Declare
						</button>
					</div>
				</div>
				{/* <button
					type="submit"
					//   disabled={disableSubmitButton}
					className="mt-6 bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700"
				>
					Declare
				</button>
				<button type="submit" class="btn btn-sm btn-success float-end">Submit</button> */}
			</form>
		</div>
	);
};

export default Codeofconduct3;
